/** Construit la query-string de pagination (`?page=&size=`) partagée par tous les endpoints paginés. */
export function pageQuery(page: number, size: number): string {
  return `?page=${page}&size=${size}`;
}
